<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 13:41:53
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-03-02 10:37:10
 * @Description:
 -->
<template>
  <mk-popover
    placement="right-start"
    popper-class="commodity-speech-storehouse-popover"
    trigger="hover"
    :width="width"
  >
    <div
      slot="reference"
      class="show-more-button"
    >
      <i class="el-icon-more"></i>
    </div>
    <div>
      <mk-tag
        v-for="(item, index) in keywordList"
        :key="index"
        class="tag-item"
        :class="isCommodity? 'commodity-item' : ''"
      >
        {{ item }}
      </mk-tag>
    </div>
  </mk-popover>
</template>

<script>
export default {
  name: 'KeywordPopover',
  props: {
    keywordList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 同popover witdt属性
    width: {
      type: [Number, String],
      default: '380'
    },
    isCommodity: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-icon-more {
  font-size: 12px;
}

.show-more-button {
  display: inline-block;
  box-sizing: border-box;
  width: 25px;
  height: 23px;
  line-height: 21px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    background-color: #e6efff;
    border: 1px solid #d5e3ff;
    border-radius: 3px;
  }
}

.tag-item {
  margin: 8px 0 0 8px;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border: none;
  background-color: #f3f3f3;
  color: #595959;
  border-radius: 2px;
}

.commodity-item {
  background-color: #e6f2ff;
  color: #409fff;
}
</style>
<style lang="scss">
.commodity-speech-storehouse-popover {
  .el-icon-more {
    font-size: 12px;
  }

  .show-more-button {
    display: inline-block;
    box-sizing: border-box;
    width: 25px;
    height: 23px;
    line-height: 21px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0);

    &:hover {
      background-color: #e6efff;
      border: 1px solid #d5e3ff;
      border-radius: 3px;
    }
  }

  .tag-item {
    margin: 8px 0 0 8px;
    height: 22px;
    line-height: 22px;
    padding: 0 8px;
    border: none;
    background-color: #f3f3f3;
    color: #595959;
    border-radius: 2px;
  }

  .commodity-item {
    background-color: #e6f2ff;
    color: #409fff;
  }
}
</style>
